import Comuni from '../../misc/comuni.json';
import { ServerConfig } from "../../../../../connectors/Config";


const AddCustomer = {
    SuperAdmin: {
        url: `${ServerConfig.AWS.Serverless.API_BASE_URL_1}/direttori`,
        method: 'POST',
        type: 'form',
        title: 'Aggiungi richiesta',
        grouped: false,
        fields: {
            "Nome e cognome": {
                type: 'string',
                length: 255,
                regex: null,
                group: "Anagrafica",
                fieldName: "name"
            },
            "Luogo di nascita": {
                type: 'string',
                length: 255,
                regex: null,
                group: "Anagrafica",
                fieldName: "luogo_di_nascita"
            },
          "Data di nascita": {
                type: 'string',
                length: 255,
                regex: null,
                group: "Anagrafica",
                fieldName: "data_di_nascita"
            },
            "Indirizzo di residenza": {
                type: 'string',
                length: 255,
                regex: null,
                group: "Anagrafica",
                fieldName: "indirizzo_residenza"
            },

            "Vicedirettore": {
                type: 'checkbox',
                regex: null,
                group: "Anagrafica",
                fieldName: "deputy"
            },
            "Modulo accreditamento": {
                type: 'file-upload-s3',
                fieldName: "modulo_file"
            },
            "Curriculum Vitae": {
                type: 'file-upload-s3',
                fieldName: "curriculum_file"
            },
            "Copia diploma": {
                type: 'file-upload-s3',
                fieldName: "diploma_file"
            },
            "PDF Certificazioni": {
                type: 'file-upload-s3',
                fieldName: "certificazioni_professionali"
            },
            "Documento d'identità": {
                type: 'file-upload-s3',
                fieldName: "documento_identita_file"
            },
            "Altro documento": {
                type: 'file-upload-s3',
                fieldName: "altri_documenti"
            }
        }
    },
    Agent: {
        url: 'http://localhost:4040/api/v1/users',
        method: 'POST',
        type: 'form',
        title: 'Aggiungi richiesta',
        fields: {
                Nome: {
                    type: 'string',
                    length: 255,
                    regex: null,
                    group: "Anagrafica"
                },
                Cognome: {
                    type: 'string',
                    length: 255,
                    regex: null,
                    group: "Anagrafica"
                },
                "Indirizzo": {
                    type: 'string',
                    length: 255,
                    regex: null,
                    group: "Anagrafica"
                },
                Civico: {
                    type: 'string',
                    length: 255,
                    regex: null,
                    group: "Anagrafica"
                },
                Comune: {
                    type: 'autocomplete',
                    length: 255,
                    choices: Comuni,
                    group: "Anagrafica"
                },
                "Codice Fiscale": {
                    type: 'string',
                    length: 255,
                    regex: "^[a-zA-Z]{6}[0-9]{2}[abcdehlmprstABCDEHLMPRST]{1}[0-9]{2}([a-zA-Z]{1}[0-9]{3})[a-zA-Z]{1}$",
                    group: "Anagrafica"
                },
                "Tipo Contratto": {
                    type: 'enum',
                    choices: ["Standard", "Voltura", "Subentro", "Cambio Offerta GAS"],
                    group: "Contratto"
                },
                "Stato Richiesta": {
                    type: 'enum',
                    choices: ["Inserita", "Firmata", "Inoltrata", "Cessata"],
                    group: "Contratto"
                },
                "Tipo cessazione": {
                    type: 'string',
                    length: 255,
                    regex: null,
                    group: "Contratto"
                },
                "Data cessazione": {
                    type: 'date',
                    format: 'DD/MM/YYYY',
                    group: "Contratto"
                },
                
                "Tipo richiesta": {
                    type: 'enum',
                    choices: ["N/A", "Domestico", "Altri usi"],
                    group: "Contratto"
                },
                "Codice Offerta": {
                    type: 'string',
                    length: 255,
                    regex: null,
                    group: "Contratto"
                },
                "Consumo annuo stimato (kWh)": {
                    type: 'number',
                    length: 7,
                    group: "Contratto"
                },
                "Contatto adesione stop carta": {
                    type: 'string',
                    length: 255,
                    regex: null,
                    group: "Contratto"
                },
                "Consumo annuo stimato (mc)": {
                    type: 'number',
                    length: 7,
                    group: "Contratto"
                },
                "Tipo Pagamento": {
                    type: 'enum',
                    choices: ["Domiciliazione", "Bollettino Postale"],
                    group: "Contratto"
                },
                "Codice socio dell'Impresa": {
                    type: 'string',
                    length: 255,
                    regex: null
                },
                "Luogo conclusione contratto": {
                    type: 'string',
                    length: 255,
                    regex: null,
                    group: "Contratto"
                },
                "POD": {
                    type: 'string',
                    length: 255,
                    regex: null,
                    group: "Contratto"
                },
                "PDR": {
                    type: 'string',
                    length: 255,
                    regex: null,
                    group: "Contratto"
                },
        },
        ACL: ['only-mine']
    }
}

export default AddCustomer;